import React from 'react';
import { Grid, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import OwlCarousel from 'react-owl-carousel';
import CardDesign from 'components/CardDesign';

export class ProductPanel extends React.Component {
  render() {
    const { products, headingKey, headingFallback } = this.props;

    return (
      <Grid container spacing={1} justify='center' style={{margin: '40px 0'}}>
        <Grid size={{xs: 12}}>
          <Typography component="span" variant='body1' gutterBottom style={{paddingLeft: '10px'}}>
            <strong>
              <FormattedMessage id={headingKey} defaultMessage={headingFallback} />
            </strong>
          </Typography>
          <OwlCarousel className='owl-theme product-panel-carousel' dots={false} loop={false} autoWidth={false} nav
            navText={["<i class='material-icons outlined'>arrow_back_ios</i>", "<i class='material-icons outlined'>arrow_forward_ios</i>"]}
            responsive={{
              0: {
                items: 1
              },
              400: {
                items: 2
              },
              767: {
                items: 4
              }
            }}
          >
            {products.map((product, index) =>
              <div className="item" key={index}>
                <CardDesign template="grid" cardDesign={product} />
              </div>
            )}
          </OwlCarousel>
        </Grid>
      </Grid>
    )
  }
}

export default ProductPanel;
